import {
  ProfileDataSettingsCardFragment,
  ProfileDataSettingsCardUserFragment,
} from 'projects/sharedComponents/src/generated/graphql-client-types';

import { FC } from 'react';

type ProfileDataSettingsCardProps = {
  user: ProfileDataSettingsCardUserFragment;
  pet: ProfileDataSettingsCardFragment;
};

// Care Resources has been retired - this component is no longer shown
export const ProfileDataSettingsCard: FC<ProfileDataSettingsCardProps> = () => {
  return null;
};
